import { FormSubmissionStatus } from "@validereinc/domain";
import { toStartCaseString } from "@validereinc/utilities";
import { omit } from "es-toolkit/compat";
import { convertMapToOpts } from "../shared/index.ts";

export const FormSubmissionStatusOptions = convertMapToOpts(
  omit(FormSubmissionStatus, ["DRAFT"]),
  ([_, value]) => toStartCaseString(value)
);
